import { CSSTransition } from 'react-transition-group'
import { common } from '@ocean/ui'
import { MaintenanceInformation } from 'core/system/types'
import { AnimatedBanner, Wrapper, CloseButton } from './MaintenanceNotifications.styled'

const { Icon, Typography } = common

type MaintenanceNotificationsProps = {
  notification?: MaintenanceInformation
  isShow: boolean
  onClose: Callback
}

const MaintenanceNotifications: React.FC<MaintenanceNotificationsProps> = props => {
  const { notification, isShow, onClose } = props
  const { preMaintenanceMessage } = notification || {}

  return (
    <CSSTransition in={isShow} classNames='banner' timeout={1000} unmountOnExit>
      <AnimatedBanner>
        <Wrapper>
          <Typography variant='small'>{preMaintenanceMessage}</Typography>
          <CloseButton onClick={onClose}>
            <Icon icon='close' />
          </CloseButton>
        </Wrapper>
      </AnimatedBanner>
    </CSSTransition>
  )
}

export default MaintenanceNotifications
